import React, {useEffect, useRef, useState, useCallback, useMemo} from "react";
import {DropDown, HeaderWrap} from "components/atoms/Header/Header.styles";
import Form from "components/molecules/Form/Form";
import Field from "components/molecules/Field";
import {FiSearch} from "react-icons/fi";
import {useForm} from "components/molecules/Form";
import {IoMdNotificationsOutline} from "react-icons/io";
import {MdDelete} from "react-icons/md";
import boy from "assets/Header/boy.svg";
import profileIcon from "assets/Header/profile-icon.svg";
import logoutIcon from "assets/Header/logout-icon.svg";
import {useNavigate} from "react-router-dom";
import {useAuthContext} from "Context/authContext";
import {useSelector, useDispatch} from "react-redux";
import notificationService from "services/notificationService";
import {formatDateTime} from "helpers/common";
import InfiniteScroll from "react-infinite-scroll-component";
import Toast from "components/molecules/Toast";
import {
    selectNotifications,
    selectUnreadCount,
    setNotifications as setNotificationsRedux,
    markAsRead as markAsReadRedux,
    markAllAsRead as markAllAsReadRedux,
    deleteNotification as deleteNotificationRedux,
    setLoading,
} from "store/reducers/notificationSlice";
import menuStoreService from "services/menu-storeService";
import Select from "components/molecules/Select";
import {IoIosArrowDown} from "react-icons/io";
import foodie from "assets/Home/foodie.svg";
import {setSelectedStoreId} from "store/reducers/businessSlice";

const Header = () => {
    const {onLogout, user, hasPermission} = useAuthContext();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [form] = useForm();
    const [notificationsOpen, setNotificationsOpen] = useState(false);
    const [userDropdown, setUserDropdown] = useState(false);
    const notificationRef = useRef(null);
    const notificationIconRef = useRef(null);
    const userIconRef = useRef(null);
    const userDropdownRef = useRef(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [hoveredNotificationId, setHoveredNotificationId] = useState(null);
    const notificationData = useSelector(selectNotifications);
    const unreadCount = useSelector(selectUnreadCount);
    const {businessId, defaultStore, selectedStoreId: selectedStoreIdFromRedux, userType} = useSelector(state => state.business);
    const [allStores, setAllStores] = useState([]);
    const [selectedStore, setSelectedStore] = useState(null);

    // Fetch stores globally
    useEffect(() => {
        if (businessId) {
            const fetchStores = async () => {
                try {
                    const res = await menuStoreService.getAllstores(businessId);
                    const storesData = res?.items || res?.data?.items || res?.stores || [];
                    setAllStores(storesData);
                    
                    if (storesData.length > 0) {
                        const targetStoreId = selectedStoreIdFromRedux || defaultStore;
                        let storeToSelect = storesData.find(s => s._id === targetStoreId);
                        
                        if (!storeToSelect) {
                            storeToSelect = storesData.find(s => s.default_branch) || storesData[0];
                            dispatch(setSelectedStoreId(storeToSelect._id));
                        }
                        
                        setSelectedStore({
                            label: storeToSelect.title || storeToSelect.name,
                            value: storeToSelect._id
                        });
                    }
                } catch (error) {
                    console.error("Error fetching stores for header:", error);
                }
            };
            fetchStores();
        }
    }, [businessId, defaultStore, selectedStoreIdFromRedux, dispatch]);

    const storeOptions = useMemo(() => {
        if (!allStores || allStores.length === 0) return [];
        
        if (userType === "restaurant_employee" && defaultStore) {
            const matchingStore = allStores.find(store => store._id === defaultStore);
            return matchingStore
                ? [
                      {
                          value: matchingStore._id,
                          label: matchingStore.title || matchingStore.name,
                      },
                  ]
                : [];
        }

        return allStores.map(store => ({
            value: store._id,
            label: store.title || store.name,
        }));
    }, [allStores, userType, defaultStore]);

    // Add a local state to force re-render when notifications change
    const [, forceUpdate] = useState({});

    const fetchNotifications = useCallback(
        async (page = 1) => {
            if (!defaultStore) return;

            try {
                dispatch(setLoading(true));
                const response = await notificationService.getAllNotifications(defaultStore, page, 10);
                if (response && response.data) {
                    const notificationsArray = Array.isArray(response.data) ? response.data : [];
                    const totalItems = notificationsArray.length;
                    dispatch(
                        setNotificationsRedux({
                            data: notificationsArray,
                            totalItems: totalItems,
                            page: page,
                        })
                    );
                    setHasMore(false); // Set to false for now, update when backend supports pagination
                }
            } catch (error) {
                console.error("❌ Error fetching notifications:", error);
                Toast({
                    type: "error",
                    message: "Failed to fetch notifications",
                });
            } finally {
                dispatch(setLoading(false));
            }
        },
        [defaultStore, dispatch]
    );

    // Fetch initial notifications when component mounts or store changes
    useEffect(() => {
        if (defaultStore) {
            fetchNotifications();
        }
    }, [defaultStore, fetchNotifications]);

    const fetchMore = () => {
        const nextPage = currentPage + 1;
        setCurrentPage(nextPage);
        fetchNotifications(nextPage);
    };

    // Listen for new notification events from socket
    useEffect(() => {
        const handleNewNotification = event => {
            const notification = event.detail;
            console.log("🔔 Header received new notification:", notification);

            // Note: Socket service already dispatched addNotification to Redux
            // Force a re-render to update the notification badge
            forceUpdate({});

            // Show toast notification
            Toast({
                type: "info",
                message: notification.title || notification.message,
            });

            // Auto-open notification dropdown for new notifications
            setNotificationsOpen(true);

            // Auto-close after 5 seconds
            setTimeout(() => {
                setNotificationsOpen(false);
            }, 5000);
        };

        window.addEventListener("new-notification", handleNewNotification);

        return () => {
            window.removeEventListener("new-notification", handleNewNotification);
        };
    }, [forceUpdate]);

    const Profile = () => {
        navigate("/settings");
        setUserDropdown(false);
    };
    const Logout = () => {
        onLogout();
        // navigate("/");
    };
    const handleClickOutside = event => {
        if (
            notificationRef.current &&
            !notificationRef.current.contains(event.target) &&
            notificationIconRef.current &&
            !notificationIconRef.current.contains(event.target)
        ) {
            setNotificationsOpen(false);
        }
        if (
            userDropdownRef.current &&
            !userDropdownRef.current.contains(event.target) &&
            userIconRef.current &&
            !userIconRef.current.contains(event.target)
        ) {
            setUserDropdown(false);
        }
    };

    const markAsRead = async item => {
        try {
            if (!item?.isRead) {
                // Mark as read in Redux
                dispatch(markAsReadRedux(item._id));

                // Call API to mark as read on server
                await notificationService.markAsRead(item._id);
                Toast({
                    type: "success",
                    message: "Notification marked as read",
                });
            }

            // Navigate to action URL if provided
            // if (item?.actionUrl) {
            //     navigate(item.actionUrl);
            // } else if (item?.actionType?.includes("order")) {
            //     navigate("/live-orders");
            // }
        } catch (error) {
            console.error("❌ Error marking notification as read:", error);
            Toast({
                type: "error",
                message: error?.message || "Failed to mark as read",
            });
        }
    };

    const markAllRead = async () => {
        try {
            if (!defaultStore) return;
            dispatch(markAllAsReadRedux());
            await notificationService.markAllAsRead(defaultStore);

            Toast({
                type: "success",
                message: "All notifications marked as read",
            });
        } catch (error) {
            console.error("❌ Error marking all as read:", error);
            Toast({
                type: "error",
                message: error?.message || "Failed to mark all as read",
            });
        }
    };

    // Delete notification
    const deleteNotification = async (e, notificationId) => {
        e.stopPropagation(); // Prevent marking as read when clicking delete

        try {
            dispatch(deleteNotificationRedux(notificationId));
            await notificationService.deleteNotification(notificationId);
            Toast({
                type: "success",
                message: "Notification deleted",
            });
        } catch (error) {
            console.error("❌ Error deleting notification:", error);
            Toast({
                type: "error",
                message: error?.message || "Failed to delete notification",
            });
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <HeaderWrap>
            <Form form={form}>
                {/* <Form.Item
                    type="search"
                    rounded
                    name="search"
                    lg
                    placeholder="Search"
                    $bgWhite
                    inputSm
                    noMargin
                    suffix={<FiSearch />}>
                    <Field />
                </Form.Item> */}
            </Form>
            <div className="navLinks" style={{display: 'flex', alignItems: 'center'}}>
                {storeOptions.length > 0 && (
                    <div className="select-holder" style={{marginRight: '15px', minWidth: '180px'}}>
                        {storeOptions.length === 1 || (hasPermission && !hasPermission("dashboard.selectstore")) ? (
                            <div style={{display: 'flex', alignItems: 'center', gap: '8px', padding: '10px 16px', background: '#fff', borderRadius: '30px', fontSize: '14px', fontWeight: '500', boxShadow: '0 2px 4px rgba(0,0,0,0.02)', border: '1px solid #f0f0f0'}}>
                                <img src={foodie} alt="store" style={{width: "16px", height: "16px"}} />
                                {selectedStore?.label}
                            </div>
                        ) : (
                            <Select
                                $bgWhite
                                value={selectedStore}
                                options={storeOptions}
                                prefix={<img src={foodie} alt="store" style={{width: "16px", height: "16px"}} />}
                                onChange={({target: {value}}) => {
                                    setSelectedStore(value);
                                    dispatch(setSelectedStoreId(value.value));
                                }}
                                suffix={<IoIosArrowDown />}
                                noMargin
                                placeholder="Select Store"
                            />
                        )}
                    </div>
                )}
                <div className="bellDrop">
                    <div
                        className="notification"
                        ref={notificationIconRef}
                        onClick={() => setNotificationsOpen(prev => !prev)}>
                        {unreadCount > 0 && <span>{unreadCount}</span>}
                        <IoMdNotificationsOutline />
                    </div>
                    <DropDown ref={notificationRef} className={` ${notificationsOpen ? "active" : ""}`}>
                        <div className="notification-header">
                            <h3>Notifications</h3>
                            {unreadCount > 0 && (
                                <span style={{fontSize: "12px", color: "#888"}}>{unreadCount} new</span>
                            )}
                        </div>
                        {unreadCount > 0 && (
                            <div className="mark-all-read" onClick={markAllRead}>
                                Mark all as read
                            </div>
                        )}
                        <div id="fetchMore">
                            <InfiniteScroll
                                dataLength={notificationData?.length}
                                next={fetchMore}
                                hasMore={hasMore}
                                loader={<span className="infinite-scroll-text">Loading...</span>}
                                scrollableTarget="fetchMore"
                                endMessage={
                                    notificationData?.length === 0 ? (
                                        <div className="empty-state">
                                            <div className="empty-icon">🔔</div>
                                            <p>No notifications yet</p>
                                        </div>
                                    ) : null
                                }>
                                {notificationData?.map((item, key) => {
                                    const getNotificationIcon = actionType => {
                                        const icons = {
                                            order_created: "🛒",
                                            order_accepted: "✅",
                                            order_preparing: "👨‍🍳",
                                            order_ready: "📦",
                                            order_completed: "🎉",
                                            order_cancelled: "❌",
                                            rider_assigned: "🚗",
                                            rider_arrived: "📍",
                                            payment_success: "💳",
                                            default: "🔔",
                                        };
                                        return icons[actionType] || icons.default;
                                    };

                                    return (
                                        <div
                                            className={`col ${!item.isRead ? "unread-notification" : ""}`}
                                            key={key}
                                            onClick={() => markAsRead(item)}
                                            onMouseEnter={() => setHoveredNotificationId(item._id)}
                                            onMouseLeave={() => setHoveredNotificationId(null)}>
                                            <div className="notification-icon">
                                                {getNotificationIcon(item?.actionType)}
                                            </div>
                                            <div className="content-holder">
                                                <div>
                                                    <span className="heading">{item?.title || item?.message}</span>
                                                    <span className="date-time">
                                                        {item?.created_at
                                                            ? formatDateTime(item.created_at)
                                                            : "Just now"}
                                                    </span>
                                                </div>
                                            </div>
                                            {!item.isRead && <div className="unread" />}
                                            {item.isRead && hoveredNotificationId === item._id && (
                                                <div
                                                    className="delete-icon"
                                                    onClick={e => deleteNotification(e, item._id)}
                                                    title="Delete notification">
                                                    <MdDelete />
                                                </div>
                                            )}
                                        </div>
                                    );
                                })}
                            </InfiniteScroll>
                        </div>
                    </DropDown>
                </div>
                <div className="btnHolder">
                    <div ref={userIconRef} onClick={() => setUserDropdown(prev => !prev)}>
                        <div className="textWrap">
                            <strong>{user?.profile?.first_name || user?.first_name || user?.name || "User"}</strong>
                            {/* <span>{user?.role_type?.length > 0 && user?.role_type[0]}</span> */}
                        </div>
                        <div className="imgWrap">
                            {user?.profilePicture ? (
                                <img src={user?.profilePicture} alt="user-profile" />
                            ) : (
                                <img src={boy} alt="userImg" />
                            )}
                        </div>
                    </div>
                    <DropDown ref={userDropdownRef} className={userDropdown ? "user-dropdown active" : "user-dropdown"}>
                        <div className="col" onClick={Profile}>
                            <figure className="icon-holder">
                                <img src={profileIcon} alt="userImg" />
                            </figure>
                            <span className="heading">Profile</span>
                        </div>
                        <div className="col" onClick={Logout}>
                            <figure className="icon-holder">
                                <img src={logoutIcon} alt="userImg" />
                            </figure>
                            <span className="heading logout">Logout</span>
                        </div>
                    </DropDown>
                </div>
            </div>
        </HeaderWrap>
    );
};

export default Header;
